import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ onLogout }) => {
  const location = useLocation();
  const [isNavOpen, setIsNavOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  const closeNav = () => setIsNavOpen(false);

  // --- NEW: DETECT SUPER ADMIN ---
  const currentUser = localStorage.getItem('adminUser');
  const isSuperAdmin = currentUser && currentUser.trim().toLowerCase() === "nsfdc.it@gmail.com";

  return (
    <nav 
      className="navbar navbar-expand-xl navbar-light shadow-sm" // CHANGED to XL for better fitting
      style={{ backgroundColor: '#ffffff', padding: '0.5rem 1.5rem' }} // Tighter padding
    >
      <div className="container-fluid">
        
        {/* --- BRANDING (Slightly scaled down to save space) --- */}
        <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeNav}>
          <img 
            src="https://ik.imagekit.io/nanoplex/Project%20Image/NSFDC/nsfdclogo-removebg-preview_aCQYROM-P.png?updatedAt=1763554348489" 
            alt="Logo" 
            style={{ height: '55px', marginRight: '8px' }} 
          />
          <div className="d-flex flex-column justify-content-center">
            <div 
              className="fw-bolder" 
              style={{ 
                fontSize: '1.2rem', 
                color: '#0D1B5E', 
                lineHeight: '1', 
                letterSpacing: '-0.5px',
                fontFamily: "'Segoe UI', sans-serif"
              }}
            >
              NSFDC
            </div>
            <div 
              className="text-uppercase fw-bold" 
              style={{ 
                color: '#000000', 
                fontSize: '0.65rem', 
                letterSpacing: '2px',
                marginTop: '4px',
                opacity: 0.8
              }}
            >
              Data Management System
            </div>
          </div>
        </Link>

        {/* --- MOBILE TOGGLER --- */}
        <button 
          className="navbar-toggler border-0" 
          type="button" 
          onClick={() => setIsNavOpen(!isNavOpen)}
          aria-controls="navbarNav"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* --- NAVIGATION LINKS --- */}
        <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center text-center">
            
            {/* Shortened Labels for Better Fit */}
             <NavItem to="/exhibitions" label="Tulip/Exhibitions" active={isActive('/exhibitions')} onClick={closeNav} />
            <NavItem to="/workshops" label="Awareness Camps" active={isActive('/workshops')} onClick={closeNav} />
            <NavItem to="/loans" label="Loans" active={isActive('/loans')} onClick={closeNav} />
            <NavItem to="/skills" label="Skills" active={isActive('/skills')} onClick={closeNav} />
         
           
            <NavItem to="/sliders" label="Sliders" active={isActive('/sliders')} onClick={closeNav} />
            <NavItem to="/users" label="App Users" active={isActive('/users')} onClick={closeNav} />

            {/* --- NEW: CONDITIONALLY RENDER SUPER ADMIN MENU --- */}
            {isSuperAdmin && (
              <NavItem 
                to="/dms-users" 
                label="DMS Admins" 
                icon="bi bi-shield-lock-fill text-danger" // Used a shield icon to denote Super Admin
                active={isActive('/dms-users')} 
                onClick={closeNav} 
              />
            )}
            {/* ------------------------------------------------ */}

            <li className="nav-item mx-1 d-none d-xl-block text-secondary opacity-25">|</li>

            <li className="nav-item ms-xl-2 mt-3 mt-xl-0 pb-3 pb-xl-0">
              <button 
                className="btn btn-warning btn-sm fw-bold px-3 shadow-sm" 
                onClick={() => { 
                  localStorage.removeItem('adminUser'); 
                  localStorage.removeItem('adminPass');
                  closeNav(); 
                  onLogout(); 
                }}
                style={{ borderRadius: '20px', fontSize: '0.85rem' }}
              >
                <i className="bi bi-box-arrow-right me-1"></i> Logout
              </button>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  );
};

// --- UPDATED NAV ITEM TO SUPPORT ICONS AND TIGHTER FONT SIZE ---
const NavItem = ({ to, label, icon, active, onClick }) => (
  <li className="nav-item mx-1 my-1 my-xl-0">
    <Link 
      className={`nav-link ${active ? 'active fw-bold' : 'fw-medium'}`} 
      to={to}
      onClick={onClick}
      style={{ 
        fontSize: '0.85rem', // Smaller font size to fit everything
        color: active ? '#0D1B5E' : 'rgba(0, 0, 0, 0.7)', 
        borderBottom: active ? '2px solid #FF9933' : '2px solid transparent', 
        padding: '0.4rem 0.6rem', // Tighter padding
        whiteSpace: 'nowrap', // Prevents words from breaking onto two lines
        transition: 'all 0.2s ease-in-out'
      }}
    >
      {icon && <i className={`${icon} me-1`}></i>}
      {label}
    </Link>
  </li>
);

export default Navbar;